export default __webpack_public_path__ + "static/media/chicken.d3e9dd54.webp";